(function() {
    'use strict';
    
    const container = document.querySelector('.product-tryon');
    if (!container) return;
    
    // Your IDs
    const VARIANT_ID = '46969571999936'; // Your actual variant ID
    const PRODUCT_ID = '8358665158848';
    
    let isProcessing = false;
    
    async function isInCart() {
        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();
            return cart.items.some(item => item.product_id.toString() === PRODUCT_ID);
        } catch (e) {
            return false;
        }
    }
    
    async function add() {
        if (await isInCart()) {
            console.log('Already in cart');
            return true;
        }
        
        try {
            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    id: VARIANT_ID,
                    quantity: 1 
                })
            });
            
            return res.ok;
        } catch (e) {
            console.error(e);
            return false;
        }
    }
    
    async function remove() {
        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();
            const item = cart.items.find(i => i.product_id.toString() === PRODUCT_ID);
            
            if (!item) return true;
            
            const removeRes = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 0 })
            });
            
            return removeRes.ok;
        } catch (e) {
            console.error(e);
            return false;
        }
    }
    
    function updateUI(active) {
        const cb = container.querySelector('.tryon-checkbox');
        const wrap = container.querySelector('.product-tryon-container');
        
        if (cb) cb.checked = active;
        if (wrap) wrap.classList.toggle('is-active', active);
    }
    
    function updateCartCount() {
        fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
                document.querySelectorAll('[data-cart-count], .cart-count').forEach(el => {
                    el.textContent = cart.item_count;
                });
            });
    }
    
    function refreshDrawer() {
        // Dispatch event for theme to refresh cart
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        
        // Also try section rendering refresh
        fetch('/?section_id=cart-drawer')
            .then(r => r.text())
            .then(html => {
                const drawer = document.querySelector('.js-cart-drawer');
                if (drawer) {
                    const temp = document.createElement('div');
                    temp.innerHTML = html;
                    const newContent = temp.querySelector('.js-cart-drawer');
                    if (newContent) {
                        drawer.innerHTML = newContent.innerHTML;
                    }
                }
            })
            .catch(e => console.log('Drawer refresh failed'));
    }
    
    function openDrawer() {
        const cartLink = document.querySelector('a[href="/cart"], .js-cart-trigger, [data-cart-trigger]');
        if (cartLink) {
            cartLink.click();
        }
    }
    
    async function onToggle(e) {
        if (isProcessing) {
            e.preventDefault();
            return;
        }
        
        const shouldAdd = e.target.checked;
        const wrap = container.querySelector('.product-tryon-container');
        
        isProcessing = true;
        if (wrap) wrap.classList.add('loading');
        
        const ok = shouldAdd ? await add() : await remove();
        
        if (ok) {
            updateUI(shouldAdd);
            updateCartCount();
            refreshDrawer();
            
            // Open drawer when adding
            // if (shouldAdd) {
            //     setTimeout(openDrawer, 300);
            // }
        } else {
            e.target.checked = !shouldAdd;
        }
        
        if (wrap) wrap.classList.remove('loading');
        isProcessing = false;
    }
    
    async function init() {
        const cb = container.querySelector('.tryon-checkbox');
        if (!cb) return;
        
        updateUI(await isInCart());
        cb.addEventListener('change', onToggle);
        console.log('Try-on ready');
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
    window.TryOn = { add, remove, check: isInCart };
})();